import React from 'react';
import { Modal, Box, Typography, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Formik, Form, Field } from 'formik';
import { TextField as formikTextField } from 'formik-material-ui';
import { Form as RBFORM } from 'react-bootstrap';
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';
import { object, string, mixed } from 'yup';
import CloseIcon from "@mui/icons-material/Close";

import noteIcon from '../../../assets/images/noteIcon.svg';
import NoteIcon from '../../icons/NoteIcon';
import UploadIn from '../../../assets/images/icon/UploadIp.svg';
import { putFormMethod } from "../../../services/apiService";

export interface EditCustomerModalProps {
    editCustomerModalOpen: boolean;
    handleEditCustomerModalClose: () => void;
    customerUserName: string;
    customerInitialValues: any;
    country: string;
    state: string;
    city: string;
    customerTimeZone: string;
    countryList: any[];
    filteredStateList: any[];
    filteredCityList: any[];
    timezoneList: any[];
    customerInputFile: any;
    customerLogoFile: any;
    handleCountryChange: (e: any, setFieldValue: any) => void;
    handleStateChange: (e: any, setFieldValue: any) => void;
    handleCityChange: (e: any, setFieldValue: any) => void;
    handleTimeZoneChange: (e: any, setFieldValue: any) => void;
    handleInputFile: (type: string) => void;
    previewImage: (e: any, type: string) => void;
    isSearching: boolean;
    searchText: string;
    fetchCustomerList: () => void;
    handleSearch: (text: string) => void;
    setToast: any;
}

export const EditCustomerModal: React.FC<EditCustomerModalProps> = ({
    editCustomerModalOpen, handleEditCustomerModalClose, customerUserName,
    customerInitialValues, country, state, city, customerTimeZone,
    countryList, filteredStateList, filteredCityList, timezoneList,
    customerInputFile, customerLogoFile, handleCountryChange, handleStateChange,
    handleCityChange, handleTimeZoneChange, handleInputFile, previewImage,
    isSearching, searchText, fetchCustomerList, handleSearch, setToast
}) => {
    return (
        <Modal
            open={editCustomerModalOpen}
            onClose={handleEditCustomerModalClose}
            className="AddFeatureM"
        >
            <Box sx={{
                maxWidth: '736px',
                width: '100%',
                margin: '64px auto 0',
                padding: '24px',
                borderRadius: '30px',
                borderColor: '#5A5F60 !important',
                border: '1px solid',
            }}
            >
                <Typography variant="h6" component="h2" gutterBottom
                    sx={{
                        fontSize: '20px',
                        color: '#E2E3E3',
                        borderBottom: '1px solid #5A5F60',
                        paddingBottom: '10px',
                        marginBottom: '30px',
                    }}
                >
                    Edit Customer - {customerUserName}
                    <span onClick={handleEditCustomerModalClose}><CloseIcon style={{ float: "right", cursor: "pointer" }}></CloseIcon></span>
                </Typography>

                <Formik
                    initialValues={customerInitialValues}
                    enableReinitialize={true} // Enable reinitialization
                    validationSchema={object({
                        partnerid: string().trim().required("Partnerid is required!"),
                        name: string().trim().required("Customer name is required!"),
                        email: string().email().required("Email ID is required!"),
                        addressline1: string().trim().optional(),
                        addressline2: string().trim().optional(),
                        postalcode: string().trim().optional(),
                        city: string().nullable().optional(),
                        state: string().nullable().optional(),
                        country: string().nullable().optional(),
                        timezone: string().nullable().optional(),
                        number: string().min(2, "Must be at least 2 digits").max(10, "Cannot be more than 10 digits").optional(),
                        mobile: string().trim().optional(),
                        customerprofileimage: mixed()
                            .nullable()
                            .optional()
                            .test(
                                "fileSize",
                                "File size should be less than 5MB",
                                (value) => {
                                    if (!value) return true; // Skip validation if value is not present (for optional files)
                                    const file = value as File; // Explicitly cast value to File type
                                    return file.size <= 5 * 1024 * 1024; // Check file size
                                }
                            )
                            .test(
                                "fileType",
                                "Unsupported file format. Only JPEG, PNG are allowed.",
                                (value) => {
                                    if (!value) return true; // Skip validation if value is not present (for optional files)
                                    const file = value as File; // Explicitly cast value to File type
                                    return ["image/jpeg", "image/png"].includes(file.type); // Check file type
                                }
                            ),
                    })}
                    onSubmit={async (values, { setSubmitting }) => {
                        let temp_values = { ...values };
                        temp_values.country = country;
                        temp_values.state = state;
                        temp_values.city = city;
                        temp_values.timezone = customerTimeZone;
                        if (temp_values.mobile != "" && !temp_values.mobile.includes("+")) {
                            temp_values = { ...temp_values, mobile: `+${temp_values.mobile}` }
                        }

                        const resp = await putFormMethod(`customer/${temp_values.enterpriseid}`, temp_values);
                        if (resp?.status === 200) {
                            if(!isSearching) fetchCustomerList();
                            else handleSearch(searchText);
                            setToast(resp?.data?.message, "success");
                            handleEditCustomerModalClose();
                        } else {
                            setToast(resp?.data?.message, "error");
                        }
                    }}
                >
                    {({ values, isSubmitting, setFieldValue, errors, touched }) => (
                        <Form>
                            <Grid container spacing={2} className="customer_popup" style={{ paddingBottom: "30px", paddingRight: "8px" }}>
                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <RBFORM.Group>
                                        <Typography variant="subtitle1"
                                            sx={{
                                                color: '#B4B7B8',
                                                fontSize: '14px',
                                            }}
                                        > Email ID<span style={{ color: "red" }}>*</span></Typography>
                                        <Field
                                            name="email"
                                            type="text"
                                            component={formikTextField}
                                            className="inputC"
                                        />
                                    </RBFORM.Group>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <RBFORM.Group>
                                        <Typography variant="subtitle1"
                                            sx={{
                                                color: '#B4B7B8',
                                                fontSize: '14px',
                                            }}
                                        > Customer Name<span style={{ color: "red" }}>*</span></Typography>
                                        <Field
                                            name="name"
                                            as="input"
                                            type="text"
                                            component={formikTextField}
                                            className="inputC"
                                        />
                                    </RBFORM.Group>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 12 }}>
                                    <RBFORM.Group>
                                        <Typography variant="subtitle1"
                                            sx={{
                                                color: '#B4B7B8',
                                                fontSize: '14px',
                                            }}
                                        > Address Line 1</Typography>
                                        <Field
                                            name="addressline1"
                                            as="input"
                                            type="text"
                                            component={formikTextField}
                                            className="inputC"
                                        />

                                    </RBFORM.Group>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 12 }}>
                                    <RBFORM.Group>
                                        <Typography variant="subtitle1"
                                            sx={{
                                                color: '#B4B7B8',
                                                fontSize: '14px',
                                            }}
                                        > Address Line 2</Typography>
                                        <Field
                                            name="addressline2"
                                            as="input"
                                            type="text"
                                            component={formikTextField}
                                            className="inputC"
                                        />
                                    </RBFORM.Group>
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Country</RBFORM.Label>
                                        <Field
                                            name="country"
                                            as="select"
                                            className="inputC custDropdown"
                                            onChange={(e: any) => handleCountryChange(e, setFieldValue)}
                                        >
                                            {countryList?.length > 0 ? (
                                                countryList.map((country: any) => (
                                                    <option key={country.id} value={country.id}>
                                                        {country.name}
                                                    </option>
                                                ))
                                            ) : (
                                                <option>Select Country</option>
                                            )}
                                        </Field>
                                    </RBFORM.Group>
                                </Grid>


                                <Grid size={{ xs: 12, md: 6 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">State</RBFORM.Label>
                                        <Field
                                            name="state"
                                            as="select"
                                            placeholder="State"
                                            className="inputC custDropdown"
                                            onChange={(e: any) => handleStateChange(e, setFieldValue)}
                                        >
                                            {filteredStateList?.length > 0 ? (
                                                filteredStateList.map((state: any) => (
                                                    <option key={state.id} value={state.id}>
                                                        {state.name}
                                                    </option>
                                                ))
                                            ) : (
                                                <option>Select State</option>
                                            )}
                                        </Field>
                                    </RBFORM.Group>
                                </Grid>


                                <Grid size={{ xs: 12, md: 6 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">City</RBFORM.Label>
                                        <Field
                                            name="city"
                                            as="select"
                                            placeholder="City"
                                            className="inputC custDropdown"
                                            onChange={(e: any) => handleCityChange(e, setFieldValue)}
                                        >
                                            {filteredCityList?.length > 0 ? (
                                                filteredCityList.map((city: any) => (
                                                    <option key={city.id} value={city.id}>
                                                        {city.name}
                                                    </option>
                                                ))
                                            ) : (
                                                <option>Select City</option>
                                            )}
                                        </Field>
                                    </RBFORM.Group>
                                </Grid>


                                <Grid size={{ xs: 12, md: 6 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Postal Code</RBFORM.Label>
                                        <Field
                                            name="postalcode"
                                            type="text"
                                            placeholder="Enter Postal Code"
                                            component={formikTextField}
                                            className="inputC"
                                        />
                                    </RBFORM.Group>
                                </Grid>


                                <Grid size={{ xs: 12, md: 6 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Phone Number</RBFORM.Label>
                                        <Field
                                            name="number"
                                            type="text"
                                            placeholder="Enter Phone Number"
                                            component={formikTextField}
                                            className="inputC"
                                        />
                                    </RBFORM.Group>
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Mobile Number</RBFORM.Label>
                                        <PhoneInput
                                            country={'us'}
                                            specialLabel=""
                                            dropdownClass="user-phone-input-dropdown"
                                            containerClass="user-phone-input-container"
                                            inputClass={`${errors.mobile ? "errors" : ""} modalForm-input user-phone-input`}
                                            inputStyle={{
                                                boxShadow: 'none',
                                                color: "#A5A8A9",
                                                border: "1px solid #313838 !important",
                                                width: "100%",
                                                height: "40px",
                                                backgroundColor: "#192529",
                                            }}
                                            value={values.mobile}
                                            onChange={(number) => setFieldValue("mobile", number)}
                                        />
                                    </RBFORM.Group>
                                </Grid>

                                <Grid size={{ xs: 12, md: 12 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Timezone </RBFORM.Label>
                                        <Field
                                            name="timezone"
                                            as="select"
                                            className="inputC custDropdown"
                                            onChange={(e: any) => handleTimeZoneChange(e, setFieldValue)}
                                            style={{ cursor: "pointer" }}
                                        >
                                            <option disabled>Select</option>
                                            {timezoneList.map((tz: any) => (
                                                <option key={tz.value} value={tz.value}>
                                                    {tz.label}
                                                </option>
                                            ))}

                                        </Field>
                                    </RBFORM.Group>
                                </Grid>

                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <span>
                                        {/* <img src={noteIcon} style={{ width: "20px", height: "20px" }} /> */}
                                        <NoteIcon />
                                    </span>
                                    <span
                                        className="label"
                                        style={{ marginLeft: "8px", marginTop: "1.5px", fontSize: "14px", fontWeight: "400", whiteSpace: "nowrap" }}
                                    >
                                        Note: If Timezone is not set, UTC time will be set as default
                                    </span>
                                </div>

                                <Grid size={{ xs: 12, md: 12 }}>
                                    <RBFORM.Group className="UploadFld">
                                        <RBFORM.Label className="label">Upload Customer Logo</RBFORM.Label>
                                        <input
                                            name="customerprofileimage"
                                            type="file"
                                            className="inputC UploadIn"
                                            onChange={(e: any) => {
                                                setFieldValue("customerprofileimage", e.currentTarget.files[0]);
                                                previewImage(e, "customerprofileimage");
                                            }}
                                            id='file'
                                            ref={customerInputFile}
                                            style={{ display: 'none' }}
                                        />
                                        <Box
                                            className="UploadIcon1"
                                            onClick={() => handleInputFile('customer')}
                                            style={{ width: '100%', height: '120px', border: '1px dashed #5A5F60', borderRadius: '8px', background: '#192529', textAlign: 'center', verticalAlign: 'middle' }}>
                                            {customerLogoFile && <img src={customerLogoFile} style={{ height: '100%', width: 'auto', float: 'left' }} />}
                                            <Box className="UploadIcon" style={{ top: "80px", cursor: 'pointer' }}>
                                                <img src={UploadIn} alt="" width={24} height={24} /> Upload Logo
                                            </Box>
                                        </Box>
                                        {/* {errors.customerprofileimage && touched.customerprofileimage && (
                                            <div style={{ color: "#d32f2f", fontSize: "0.75rem" }}>Customer logo is required!</div>
                                        )} */}
                                    </RBFORM.Group>
                                </Grid>
                            </Grid>

                            <input type="hidden" name="enterpriseid" />
                            {/* {JSON.stringify(values, null, 2)} */}

                            <Box sx={{ display: "flex", borderTop: "1px solid #5A5F60", paddingTop: '20px', justifyContent: "flex-end", gap: 2 }}>
                                <Button type="button" onClick={handleEditCustomerModalClose} variant="outlined"
                                    sx={{ color: '#0699CE', textTransform: 'capitalize', height: '41px', lineHeight: '41px', borderColor: '#0B4A62', borderRadius: '25px', fontSize: '14px', fontWeight: '500', }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    disabled={isSubmitting}
                                    sx={{
                                        color: '#1F2F34', height: '41px', lineHeight: '41px',
                                        borderColor: '#0B4A62', background: '#17B2EB',
                                        borderRadius: '25px', fontSize: '14px',
                                        fontWeight: '500',
                                        textTransform: 'capitalize',
                                    }}
                                >
                                    Save Changes
                                </Button>
                            </Box>
                        </Form>
                    )}
                </Formik>
            </Box>
        </Modal>
    );
};